import { useEffect, useState } from "react";
import { useAvtovazRequisites } from "./useAvtovazRequisites";

export const useGetActiveRequisite = () => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const { getAvtovazActiveRequisiteList } = useAvtovazRequisites();

  const fetchData = async () => {
    try {
      const res = await getAvtovazActiveRequisiteList();
      if (res.status >= 400) {
        setError("Ошибка получения активных реквизитов");
      }
      setData(res.data);
    } catch (error) {
      setError("Ошибка получения активных реквизитов");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return { data, isLoading, error };
};
